import { initializeApp } from 'firebase/app';
import { connectAuthEmulator, getAuth } from 'firebase/auth';
import { getFirestore, connectFirestoreEmulator } from 'firebase/firestore';

import firebaseConfig from '@/firebase.config';
import { CompassAdminContextType } from '@/src/libs/CompassAdminContext';
import { CompassContextType } from '@/src/libs/CompassContext';

export const initializeFirebase = (
  ctx: CompassContextType | CompassAdminContextType,
  useFirebaseEmulator: 'true' | 'false' = 'false'
) => {
  if (!useFirebaseEmulator && (!ctx || ctx.state.firestore)) return;

  if (
    useFirebaseEmulator === 'true' &&
    !firebaseConfig.projectId?.startsWith('demo-')
  ) {
    throw new Error('Firebase emulator mode requires a demo-* project ID.');
  }

  const appInstance = initializeApp(firebaseConfig);

  if (appInstance) {
    const firestoreInstance = getFirestore(appInstance);

    if (useFirebaseEmulator === 'true') {
      console.log('Using firebase emulator');
      connectFirestoreEmulator(firestoreInstance, 'localhost', 8080);
      const authInstance = getAuth(appInstance);
      connectAuthEmulator(authInstance, 'http://127.0.0.1:9099');
    }
    ctx?.dispatch({
      type: 'SET_FIRESTORE',
      payload: firestoreInstance,
    });
  }
};
